/* Standalone Gold content section; purchase selection remains owned by the product. */
(() => {
  window.GrovaSections.register('grova-gold-drawer', '[data-gold-drawer-section]', (root, scope) => {
    const modal = root.querySelector('[data-modal="gold-benefits"]');
    const panel = modal.querySelector('.gnp-modal__dialog');
    const section = root.closest('.shopify-section') || root;
    let returnFocus, releaseScroll, closeTimer, touchY = 0;
    const triggerForPage = () => document.querySelector('[data-external-gold-drawer] [data-open-modal="gold-benefits"]');
    function finish(restoreFocus = true) {
      clearTimeout(closeTimer);
      modal.hidden = true;
      modal.classList.remove('is-closing', 'is-opening');
      releaseScroll?.();
      releaseScroll = null;
      if (restoreFocus && returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    }
    function close() {
      if (modal.hidden || modal.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return finish();
      modal.classList.add('is-closing');
      const timing = getComputedStyle(modal).getPropertyValue('--grova-drawer-duration').trim();
      const duration = (parseFloat(timing) * (timing.endsWith('ms') ? 1 : 1000)) || 300;
      closeTimer = scope.timeout(finish, duration);
    }
    function open(trigger = triggerForPage()) {
      clearTimeout(closeTimer);
      returnFocus = trigger;
      releaseScroll ||= window.GrovaPageScroll.lock(root);
      document.dispatchEvent(new CustomEvent('grova:product-modals-close'));
      modal.classList.remove('is-closing');
      modal.classList.add('is-opening');
      modal.hidden = false;
      panel.offsetHeight;
      modal.classList.remove('is-opening');
      panel.querySelector('[data-close-modal]')?.focus({ preventScroll: true });
    }
    scope.on(document, 'click', event => {
      const trigger = event.target.closest('[data-open-modal="gold-benefits"]');
      if (trigger?.closest('[data-external-gold-drawer]')) open(trigger);
    });
    scope.on(root, 'click', event => {
      if (event.target.closest('[data-close-modal]')) close();
    });
    scope.on(document, 'grova:gold-drawer-close', () => finish(false));
    scope.on(document, 'keydown', event => {
      if (modal.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key === 'Tab') {
        const items = [...panel.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]')]
          .filter(el => !el.disabled && !el.closest('[hidden]') && el.tabIndex >= 0);
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
      if (!panel.contains(event.target) && ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) event.preventDefault();
    });
    scope.on(document, 'wheel', event => {
      if (!modal.hidden && !window.GrovaPageScroll.canScrollWithin(event.target, panel, event.deltaY)) event.preventDefault();
    }, { passive: false });
    scope.on(document, 'touchstart', event => { touchY = event.touches[0]?.clientY || 0; }, { passive: true });
    scope.on(document, 'touchmove', event => {
      if (modal.hidden) return;
      const y = event.touches[0]?.clientY || 0;
      if (!window.GrovaPageScroll.canScrollWithin(event.target, panel, touchY - y)) event.preventDefault();
      touchY = y;
    }, { passive: false });
    scope.on(section, 'shopify:section:select', () => open());
    scope.on(section, 'shopify:block:select', event => {
      open();
      event.target.closest('[data-gold-benefit]')?.scrollIntoView?.({ block: 'nearest', behavior: 'instant' });
    });
    scope.on(section, 'shopify:section:deselect', () => finish(false));
    scope.on(document, 'shopify:section:unload', event => {
      if (event.target.querySelector('[data-external-gold-drawer]')) finish(false);
    });
    scope.cleanup(() => finish(false));
  });
})();
